module.exports = __webpack_public_path__ + "img/taiwan.09021807.png";